var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "FormFieldContainerFacturacion",
                        { attrs: { titulo: "Detalle " + _vm.tituloDocumento } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Folio",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.folio.id
                                  ),
                                  "data-vv-name": _vm.formFields.folio.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.folio.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.folio, "value", $$v)
                                  },
                                  expression: "formFields.folio.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-flex", {
                            staticClass: "pl",
                            attrs: { xs12: "", sm12: "", md12: "" }
                          }),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Comuna",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.comuna.id
                                  ),
                                  "data-vv-name": _vm.formFields.comuna.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.comuna.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.comuna,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.comuna.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Ciudad",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.ciudad.id
                                  ),
                                  "data-vv-name": _vm.formFields.ciudad.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.ciudad.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.ciudad,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.ciudad.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.nombreRS.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombreRS.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombreRS.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.nombreRS.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombreRS,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombreRS.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.rut.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.rut.id
                                  ),
                                  "data-vv-name": _vm.formFields.rut.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.rut.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.rut, "value", $$v)
                                  },
                                  expression: "formFields.rut.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.direccion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.direccion.id
                                  ),
                                  "data-vv-name": _vm.formFields.direccion.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.direccion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.direccion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.direccion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.giro.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.giro.id
                                  ),
                                  "data-vv-name": _vm.formFields.giro.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.giro.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.giro, "value", $$v)
                                  },
                                  expression: "formFields.giro.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.fechaEmision.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaEmision.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.fechaEmision.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.fechaEmision.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaEmision,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaEmision.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.condicionPago.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.condicionPago.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.condicionPago.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.condicionPago.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.condicionPago,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.condicionPago.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }